import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { get } from '@wp-g2/styles';
import React from 'react';
import { BarsView, BarsWrapperView, ContainerView } from './Spinner.styles';
import { BASE_SIZE, WRAPPER_SIZE } from './Spinner.utils';
/**
 * @typedef Props
 * @property {import('react').CSSProperties['color']} [color] Color of `Spinner`.
 * @property {number} [size=16] Size of `Spinner`.
 */

/**
 *
 * @param {import('@wp-g2/create-styles').ViewOwnProps<Props, 'div'>} props
 * @param {import('react').Ref<any>} forwardedRef
 */

function Spinner(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'Spinner'),
      _useContextSystem$col = _useContextSystem.color,
      color = _useContextSystem$col === void 0 ? get('colorText') : _useContextSystem$col,
      _useContextSystem$siz = _useContextSystem.size,
      size = _useContextSystem$siz === void 0 ? BASE_SIZE : _useContextSystem$siz,
      otherProps = _objectWithoutProperties(_useContextSystem, ["color", "size"]);

  return /*#__PURE__*/React.createElement(ContainerView, Object.assign({}, otherProps, {
    "aria-busy": true,
    ref: forwardedRef,
    style: {
      height: size,
      width: size
    }
  }), /*#__PURE__*/React.createElement(BarsWrapperView, {
    "aria-hidden": true,
    style: {
      transform: "scale(" + size / BASE_SIZE * BASE_SIZE / WRAPPER_SIZE + ")"
    }
  }, /*#__PURE__*/React.createElement(BarsView, {
    style: {
      color: color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "InnerBar1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "InnerBar2"
  }), /*#__PURE__*/React.createElement("div", {
    className: "InnerBar3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "InnerBar4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "InnerBar5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "InnerBar6"
  }), /*#__PURE__*/React.createElement("div", {
    className: "InnerBar7"
  }), /*#__PURE__*/React.createElement("div", {
    className: "InnerBar8"
  }), /*#__PURE__*/React.createElement("div", {
    className: "InnerBar9"
  }), /*#__PURE__*/React.createElement("div", {
    className: "InnerBar10"
  }), /*#__PURE__*/React.createElement("div", {
    className: "InnerBar11"
  }), /*#__PURE__*/React.createElement("div", {
    className: "InnerBar12"
  }))));
}

export default contextConnect(Spinner, 'Spinner');